import React from 'react';
import { COMMON_FLAGS, useConfigMatch } from 'modules/taboola-common-frontend-modules/account-configurations';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { validationFunctions } from 'modules/taboola-common-frontend-modules/validations';
import { accessibleUrlValidation } from 'modules/tracking/components/codelessConversions/ValidateWebsiteUrlTracking';
import { UrlInputWithValidation } from './components/UrlInputWithValidation';
import styles from './websiteUrlTestEvents.module.scss';

export const urlValidation = {
    validationFn: validationFunctions.isURL,
    messageId: 'validations.error.field.url.invalid',
    defaultMessage: 'Please enter a valid URL',
};

export const WebsiteUrlTestEvents = () => {
    const isTfaValidationEnabled = useConfigMatch({}, { [COMMON_FLAGS.PIXEL_TESTER_TFA_VALIDATION_ENABLED]: 'true' });
    const useValidations = isTfaValidationEnabled ? [urlValidation, accessibleUrlValidation] : [urlValidation];

    return (
        <div className={styles['website-url-container']}>
            <div className={styles['content-header']}>
                <FormattedMessage
                    id="pixel.tester.website.url.subTitle"
                    defaultMessage='Enter your website URL and click "Generate QR code".'
                    className={styles['info-text']}
                />
                <UrlInputWithValidation validations={useValidations} />
            </div>
        </div>
    );
};
